export default __webpack_public_path__ + "static/media/Plant_Render.8d69abc4.mp4";